module.exports = __webpack_public_path__ + "img/logo-company.62c011db.png";